//@ts-check
import QRCodeCard from "../../../utils/QrCodeCard";
import numberWithCommas from "../../../utils/numbersWithComma";

const FORMAT_TYPES = {
  text: "string",
  number: "number",
  qrCodeValue: "qrcode",
  image: "image",
};

const RenderValue = ({ item }) => {
  switch (item?.format) {
    case FORMAT_TYPES.text:
      return (
        <div className="displaying-text-number">
          <div className="displaying-label">{`${item?.label}${
            item?.value && ":"
          }`}</div>
          <div className="displayng-text">{item?.value}</div>
        </div>
      );
    case FORMAT_TYPES.number:
      return (
        <div className="displaying-text-number">
          {" "}
          <div className="displaying-label">{`${item?.label} ${
            item?.value && ":"
          }`}</div>
          {item?.value && (
            <div className="displayng-text">
              {numberWithCommas(item?.value)}{" "}
            </div>
          )}
        </div>
      );
    case FORMAT_TYPES.qrCodeValue:
      return (
        <div>
          <div className="label">{`${item?.label}`}</div>
          <div className="displaying-qrcode">
            <QRCodeCard text={item?.value} />
          </div>
        </div>
      );
    case FORMAT_TYPES.image:
      return (
        <div style={{ display: "flex" }}>
          <div className="label" style={{ fontSize: "12px" }}>
            {`${item?.label}`}{" "}
            {/* {SHOW_COPY_BUTTON && <CopyText text={item?.label} />} */}
          </div>

          <div className="image-container">
            <img className="displayng-img my-3" src={item?.value} />
          </div>
        </div>
      );
    default:
      return (
        <div className="">
          {" "}
          {/* <div className="displaying-label">{`${item?.label}:`}</div> */}
          <div className="displayng-text">{item?.value}</div>
        </div>
      );
  }
};

const DisplayValues = ({ displayItems = [] }) => {
  return (
    <>
      {displayItems.length > 0 && (
        <div className={`display-values-section`}>
          {displayItems?.map((item, idx) => (
            <div key={idx} className="item">
              {/* <div className="displaying-label">{`${item?.label}:`}</div> */}
              <RenderValue item={item} />
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default DisplayValues;
